import { render, staticRenderFns } from "./AccountingFiche.vue?vue&type=template&id=0bab37c2&"
import script from "./AccountingFiche.vue?vue&type=script&lang=js&"
export * from "./AccountingFiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports